<template>
  <div class="w-full h-[800px] flex flex-col relative">
    <Loading v-if="isLoading" class="p-16">
      <p class="text-base text-gray-800">Loading...</p>
    </Loading>
    <iframe
      id="canvas-iframe"
      ref="iframeRef"
      :src="iframeSrc"
      title="Preview Canvas"
      class="w-full h-full border-none transition-opacity duration-300"
      :class="{ 'opacity-0 pointer-events-none': isLoading }"
      frameborder="0"
      allowfullscreen
      @load="onIframeLoad"
    />
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from "vue";
import Loading from "@/components/UI/Loading/Loading.vue";

const props = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
  canvas_id: {
    type: String,
    default: "",
  },
  // Ready-to-use preview link (canvas3dPreview). When present it is rendered as is,
  // without the canvas_id/scene/token handshake.
  preview_url: {
    type: String,
    default: "",
  },
  canvas_scene: {
    type: String,
    default: "",
  },
  canvas_token: {
    type: String,
    default: "",
  },
});

const iframeSrc = computed(
  () => props.preview_url || `https://canvas.cockpit3d.com/canvas/${props.canvas_id}`
);
const iframeRef = ref(null);
const isLoading = ref(true);
const onIframeLoad = () => {
  // Without a scene/token there is no canvas handshake, so hide the spinner on load.
  if (props.preview_url || (!props.canvas_scene && !props.canvas_token)) {
    isLoading.value = false;
  }
};
const iframeLoad = () => {
  if (iframeRef.value && iframeRef.value.contentWindow) {
    if (props.canvas_scene) {
      iframeRef.value.contentWindow.postMessage(
        {
          event: {
            type: "set_scene",
            scene: JSON.parse(props.canvas_scene),
          },
        },
        "https://canvas.cockpit3d.com"
      );
    }
    if (props.canvas_token) {
      iframeRef.value.contentWindow.postMessage(
        {
          event: {
            type: "set_token",
            token: props.canvas_token,
          },
        },
        "https://canvas.cockpit3d.com"
      );
    }
    iframeRef.value.contentWindow.postMessage(
      {
        event: {
          type: "set_viewport_mode",
          mode: "preview",
        },
      },
      "https://canvas.cockpit3d.com"
    );
  }
  isLoading.value = false;
};
const handleMessage = (event) => {
  if (props.preview_url || event.origin !== "https://canvas.cockpit3d.com") {
    return;
  }
  if (event.data.event) {
    switch (event.data.event.type) {
      case "all_actions_complete":
        iframeLoad();
        break;
      default:
    }
  }
};

onMounted(() => {
  window.addEventListener("message", handleMessage);
});

onUnmounted(() => {
  window.removeEventListener("message", handleMessage);
});
</script>
